export const ITERATION_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FORCECOMPLETED: 'force_completed',
};

export const TABLE_SAMPLE_COLUMN = [
  {
    field: 'id',
    name: 'ID',
    type: 'integer',
    sort: false,
    showColumn: true,
  },
  {
    field: 'icon',
    name: 'Иконка',
    type: 'image',
    sort: false,
    showColumn: true,
  },
  {
    field: 'barcode_value',
    name: 'Штрихкод',
    type: 'string',
    sort: false,
    showColumn: true,
  },
  {
    field: 'storage_name',
    name: 'Хранилище',
    type: 'string',
    sort: false,
    showColumn: true,
  },
  {
    field: 'pack_name',
    name: 'Штатив',
    type: 'string',
    sort: true,
    showColumn: true,
  },
  {
    field: 'position',
    name: 'Позиция',
    type: 'string',
    sort: true,
    showColumn: true,
  },
];
